import styled from 'styled-components'

import {BodySelector} from '@/src/config/settings'
import theme, {media} from '@/src/config/theme'

export const Title = styled.div`
  font-size: 1.25rem;
  font-weight: 450;
`

export const Component = styled.div`
  ${BodySelector} & .ant-collapse-item {
    background-color: ${theme.colors.grayTransparent};

    & .ant-collapse-expand-icon {
      display: none;

      // @media ${media.md} {
      //   display: inherit;
      // }
    }
  }
`

export const ListItemHead = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const Row = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const ListItemContent = styled.div`
  display: flex;
  flex-direction: column;

  & > * {
    padding-top: 8px;
    padding-bottom: 8px;
    border-top: solid 1px ${theme.colors.gray6};

    &:first-child {
      padding-top: unset;
      border-top: unset;
    }

    &:last-child {
      padding-bottom: unset;
    }
  }
`

export const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export const InfoRow = styled(Row)`
  gap: 10px;

  justify-content: flex-start;

  flex-direction: column;

  & > *:first-child {
    white-space: nowrap;
  }

  @media ${media.md} {
    //gap: 25px;
    flex-direction: row;
  }
`
